import MuiCssBaseline from './MuiCssBaseline'
import MuiButton from './MuiButton'
import MuiCardActions from './MuiCardActions'
import MuiCardContent from './MuiCardContent'
import MuiCardHeader from './MuiCardHeader'
import MuiChip from './MuiChip'
import MuiDialog from './MuiDialog'
import MuiIconButton from './MuiIconButton'
import MuiInputBase from './MuiInputBase'
import MuiLinearProgress from './MuiLinearProgress'
import MuiLink from './MuiLink'
import MuiListItem from './MuiListItem'
import MuiListItemIcon from './MuiListItemIcon'
import MuiOutlinedInput from './MuiOutlinedInput'
import MuiPaper from './MuiPaper'
import MuiTableCell from './MuiTableCell'
import MuiTableHead from './MuiTableHead'
import MuiTableRow from './MuiTableRow'
import MuiToggleButton from './MuiToggleButton'
import MuiTypography from './MuiTypography'
import MuiInputLabel from './MuiInputLabel'
import MuiTab from './MuiTab'
import MuiDivider from './MuiDivider'
import MuiAvatar from './MuiAvatar'
import MuiPickersCalendar from './MuiPickersCalendar'
import MuiSelect from './MuiSelect'
import StorfoxTable from './StorfoxTable'
import StorfoxSidebar from './StorfoxSidebar'
import StorfoxHeader from './StorfoxHeader'
import StorfoxListPanel from './StorfoxListPanel'
import StorfoxMenuCard from './StorfoxMenuCard'

export default primaryColor => ({
  MuiCssBaseline,
  MuiButton,
  MuiCardActions,
  MuiCardContent,
  MuiCardHeader,
  MuiChip,
  MuiDialog,
  MuiIconButton,
  MuiInputBase,
  MuiLinearProgress,
  MuiLink,
  MuiListItem,
  MuiListItemIcon,
  MuiOutlinedInput,
  MuiPickersCalendar,
  MuiPaper,
  MuiSelect,
  MuiTableCell,
  MuiTableHead,
  MuiTableRow,
  MuiToggleButton,
  MuiTypography,
  MuiTab,
  MuiDivider,
  MuiAvatar,
  MuiInputLabel,
  StorfoxTable,
  StorfoxSidebar: StorfoxSidebar(primaryColor),
  StorfoxHeader,
  StorfoxListPanel,
  StorfoxMenuCard
})
